/* MIYEGO: section-entry reveal (the one motion moment) + sticky mobile ATC. */
(function () {
  // Scroll reveal — once per element, motion-safe (CSS gates the transition).
  var revealables = document.querySelectorAll('.miyego-reveal');
  if (revealables.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -60px 0px', threshold: 0.1 }
    );
    revealables.forEach(function (el) { io.observe(el); });

    // Safety net: nothing stays hidden just because the observer never fired.
    window.addEventListener('load', function () {
      setTimeout(function () {
        revealables.forEach(function (el) { el.classList.add('is-visible'); });
      }, 1200);
    });
  } else {
    revealables.forEach(function (el) { el.classList.add('is-visible'); });
  }

  // Sticky mobile ATC — shows once the buy column scrolls out of view.
  var bar = document.querySelector('.miyego-sticky-atc');
  var info = document.querySelector('.product__info-wrapper');
  if (bar && info && 'IntersectionObserver' in window) {
    var barIo = new IntersectionObserver(
      function (entries) {
        var show = !entries[0].isIntersecting;
        bar.classList.toggle('is-active', show);
        bar.inert = !show;
      },
      { rootMargin: '0px' }
    );
    barIo.observe(info);

    var button = bar.querySelector('.miyego-sticky-atc__button');
    if (button) {
      button.addEventListener('click', function () {
        var form = document.querySelector('product-form form[data-type="add-to-cart-form"]');
        if (form) {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
        }
      });
    }
  }
})();
